import React from 'react';
import type { FilterMenuOption } from '@goodfynd/ui';
import { Autocomplete } from '@goodfynd/ui';

import { useOrganizationApi } from '../../../hooks/api';

import type { AutocompleteOrganizationsProps } from './types';

export function AutocompleteOrganizations({
  idPropertyName = 'nameId',
  ...props
}: AutocompleteOrganizationsProps) {
  const api = useOrganizationApi();
  return (
    <Autocomplete<FilterMenuOption>
      label="Organization"
      placeholder="Find organization..."
      getOptions={async (request) => {
        try {
          const { results } = await api.autocomplete(request);
          return results.map((result) => ({
            description: result.nameId,
            image: result.image,
            label: result.uniqueName || result.name,
            value: result[idPropertyName] || result.id,
          }));
        } catch (error) {
          console.error(error);
          return [];
        }
      }}
      {...props}
    />
  );
}
